import GeometryCollection from 'ol/geom/GeometryCollection';
import { LineString } from 'ol/geom';
import smoothPath from '../../utils/geomUtils';
import { drawBarbs, drawCalm } from './windGeometry';
import { getUnitFactor } from '../../utils/unitConversion';

const drawBentLine = (coordinates, size, smoothLevel, y, x) => {
  const o = {
    top: 1,
    bottom: -1,
    left: -1,
    rigth: 1
  };
  const shiftX = o[x] * size;
  const shiftY = o[y] * size;
  return new LineString(smoothPath([[coordinates[0], coordinates[1] + shiftY], [coordinates[0] + shiftX, coordinates[1] + shiftY], [coordinates[0] + shiftX * 1.8, coordinates[1]]], smoothLevel));
};

const drawNorthHemisphereLines = (coordinates, size) => {
  const lineTop = drawBentLine(coordinates, size, 10, 'top', 'rigth');
  const lineBottom = drawBentLine(coordinates, size, 10, 'bottom', 'left');
  return [lineTop, lineBottom];
};

const drawSouthHemisphereLines = (coordinates, size) => {
  const lineTop = drawBentLine(coordinates, size, 10, 'top', 'left');
  const lineBottom = drawBentLine(coordinates, size, 10, 'bottom', 'rigth');
  return [lineTop, lineBottom];
};

const drawSmallHurricane = ({
  coordinates,
  size
}) => {
  const coefficientHemisphere = coordinates[1] > 0 ? 1 : -1;
  const calm = drawCalm(coordinates, size);
  const lines = coordinates[1] > 0 ? drawNorthHemisphereLines(coordinates, size) : drawSouthHemisphereLines(coordinates, size);
  const elements = [calm, ...lines];
  const smallHurricane = new GeometryCollection(elements);
  smallHurricane.rotate(coefficientHemisphere * Math.PI / 4, coordinates);
  return smallHurricane;
};

export const drawHurricane = ({
  count,
  coordinates,
  size,
  speedKN
}) => {
  const d = 2 * Math.PI / count;
  const hurricane = [];
  const coefficientHemisphere = coordinates[1] > 0 ? -1 : 1;

  for (let i = 0; i < count; i += 1) {
    const angle = d * i;
    const x = coordinates[0] + size * Math.sin(angle);
    const y = coordinates[1] + size * Math.cos(angle);
    hurricane.push(drawBarbs({
      coordinates: [x, y],
      speedKN,
      direction: coefficientHemisphere * Math.PI / 2 - angle,
      size
    }));
  }

  return new GeometryCollection(hurricane);
};
export default (({
  sizeFactor,
  count
}) => function hurricaneGeometry(feature, resolution, params) {
  const unitConvenerFactor = getUnitFactor(params.unit);
  const props = feature.getProperties();
  const geometry = feature.getGeometry();
  const coordinates = geometry.getCoordinates();
  const {
    WindSpeed: windSpeed
  } = props;
  const speedKN = windSpeed * unitConvenerFactor;
  const size = resolution * sizeFactor;
  const R = resolution / speedKN;

  if (R < 50) {
    return drawHurricane({
      count,
      coordinates,
      size,
      speedKN
    });
  }

  return drawSmallHurricane({
    coordinates,
    size
  });
});
export const circleGeometry = ({
  sizeFactor
}) => (feature, resolution, params) => {
  const props = feature.getProperties();
  const geometry = feature.getGeometry();
  const coordinates = geometry.getCoordinates();
  const {
    WindSpeed: windSpeed
  } = props;
  const unitConvenerFactor = getUnitFactor(params.unit);
  const speedKN = windSpeed * unitConvenerFactor;
  const size = resolution * speedKN * sizeFactor;
  return drawCalm(coordinates, size);
};